import { v4 as uuidv4 } from 'uuid'

import {
  FILE_NAME,
  FILE_TYPE,
  FILE_URL,
  MEDIA_DURATION,
  MEDIA_HEIGHT,
  MEDIA_TYPE,
  MEDIA_WIDTH,
  UPLOADED_MEDIA_TYPE
} from '../../../../ReusableFormFields/AdFileUpload/fields'
import { LABELS } from '../reusableFields/fields'
import { IS_QUARANTINE } from '../../../../reusableFields'

export const AD_TYPE_IMAGE = 'image'
export const AD_TYPE_VIDEO = 'video'
export const AD_TYPE_OPTION = 'ad_type_option'

export const NAME = 'name'

// URLs fields
export const CLICK_THROUGH_LINK = 'destination_url'
export const CLICK_THROUGH_URL_OPTION = 'destination_url_option'
export const SAME_URL_TYPE = 'same_url_type'
export const DIFFERENT_URL_TYPE = 'different_url_type'

// Video Creatives Upload Flow
export const VIDEO_UPLOAD_TYPE = 'video_upload_type'
export const VIDEO_EXTERNAL_HOST_TYPE = 'video_external_host_type'
export const VIDEO_VAST_XML_TYPE = 'video_vast_xml_type'
export const VIDEO_EXISTING_LIBRARY_TYPE = 'video_existing_library_type'

// Display Creatives Upload Flow
export const IMAGE_UPLOAD_TYPE = 'image_upload_type'
export const IMAGE_EXTERNAL_HOST_TYPE = 'image_external_host_type'
export const IMAGE_EXISTING_LIBRARY_TYPE = 'image_existing_library_type'

// files upload:
export const UPLOADED_MEDIA_LIST = 'uploaded_media_list'
export const initialGamFileValues = {
  [FILE_NAME]: '',
  [FILE_URL]: '',
  [FILE_TYPE]: '',
  [MEDIA_TYPE]: '',
  [UPLOADED_MEDIA_TYPE]: '',
  [MEDIA_DURATION]: null,
  [MEDIA_WIDTH]: null,
  [MEDIA_HEIGHT]: null
}

export const getInitialValues = (formatOption, isInternalAdCreation) => ({
  [NAME]: '',
  [LABELS]: [],
  [UPLOADED_MEDIA_LIST]: [
    {
      ...initialGamFileValues,
      id: uuidv4()
    }
  ],
  [CLICK_THROUGH_URL_OPTION]: SAME_URL_TYPE,
  [CLICK_THROUGH_LINK]: 'https://',
  [AD_TYPE_OPTION]: formatOption,
  [IS_QUARANTINE]: isInternalAdCreation
})
